import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAnchorStyle0 = gravityIconIndividualCss;

const GravityIconAnchor = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '7f557fed65783a6b066f1d45bf306bca34ccd67d', color: this.color, size: this.size }, h("svg", { key: 'c48ad104229ab2c66cb53c59a6b75fae6b5f3953', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'a585b20c7906dfa46b54e39d0b9f61d0d73fde65', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.5 4.59c0 1.12.737 2.068 1.752 2.386V8.42H7.858a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h2.394v8.543a7.505 7.505 0 0 1-6.62-6.055.389.389 0 0 0-.378-.32h-.766c-.225 0-.4.197-.362.419C2.843 16.76 6.543 20 11 20c4.457 0 8.157-3.24 8.874-7.493a.362.362 0 0 0-.362-.419h-.766a.389.389 0 0 0-.378.32 7.505 7.505 0 0 1-6.616 6.055V9.92h2.394a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-2.394V6.975A2.501 2.501 0 1 0 8.5 4.59Zm2.252.936a.503.503 0 0 0-.085.007 1 1 0 1 1 .667 0 .504.504 0 0 0-.082-.007h-.5Z", fill: "currentColor" }))));
    }
};
GravityIconAnchor.style = GravityIconAnchorStyle0;

export { GravityIconAnchor as gravity_icon_anchor };

//# sourceMappingURL=gravity-icon-anchor.entry.js.map